import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { Button, Box, Typography, CircularProgress, TextField, MenuItem } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';
import Galaryimageupload from './Galaryimageupload';
import Accomplishments from './Accomplishments';
import NewsManagement from './NewsManagement';

import DynamicValuesManager from './DynamicValuesManager';
// import NewsTab from './tabs/NewsTab';
import YouTubeLinksManager from './YouTubeLinksManager';
import AssociationsManager from './AssociationsManager';

import HelpNeededManager from './Helpneededlist';
import AdminUserManagement from './AdminUserManagement'

import Eventimageupload from './Eventimageupload'
import BannerUpload from './BannerUpload'
import Events from './Events';
import CommunityMeetupsManager from './CommunityMeetupsManager';
import CommunityMeetupRegistrations from './CommunityMeetupRegistrations';
import EventRegistrationsManager from './EventRegistrationsManager';
import VolunteerCertificatesManager from './VolunteerCertificatesManager';
import ExamSimulationsAdmin from './ExamSimulationsAdmin';

import TechSummitRegistrations from './TechSummitRegistrations';

import Emailcommunication from './Emailcommunication';
import AboutCommunityManager from './AboutCommunityManager';
import TrainingProgramsManager from './TrainingProgramsManager';
import SiteAnalytics from './SiteAnalytics';
import OpportunityContactRequests from './OpportunityContactRequests';
import ProviderNetworkAdmin from './PunditPurohit/components/ProviderNetworkAdmin';
import { resolvePunditImageUrl } from './PunditPurohit/utils/imageUrl';

const adminGroups = [
  {
    title: 'Intake & Approvals',
    description: 'Review new people, partners, providers, and opportunity follow-ups.',
    items: [
      {
        key: 'signup-requests',
        label: 'Signup Requests',
        helper: 'Approve or reject new UC members.',
      },
      {
        key: 'enterprise-onboarding',
        label: 'Enterprise Onboarding',
        helper: 'Approve business and organization requests.',
      },
      {
        key: 'pundit-approvals',
        label: 'Pundit Approvals',
        helper: 'Review Divine Rituals priest onboarding.',
      },
      {
        key: 'opportunity-contacts',
        label: 'Opportunity Contacts',
        helper: 'Follow up on UC Companion profile requests.',
      },
    ],
  },
  {
    title: 'Divine Rituals',
    description: 'Manage the Pundit Purohit service catalog and monetization.',
    items: [
      {
        key: 'pooja-management',
        label: 'Pooja Management',
        helper: 'Pooja details, pricing, images, hero, prasadam, and service coverage.',
      },
      {
        key: 'pooja-orders',
        label: 'Pooja Orders',
        helper: 'View Divine Rituals bookings, customers, schedules, and status.',
      },
      {
        key: 'pooja-testimonials',
        label: 'Devotee Testimonials',
        helper: 'Review devotee feedback before showing it publicly.',
      },
      {
        key: 'provider-network',
        label: 'Pandit & Seva Network',
        helper: 'Review provider profiles, service roles, availability, and referrals.',
      },
      {
        key: 'pooja-subscriptions',
        label: 'Pooja Subscriptions',
        helper: 'Subscription plans and add-on items.',
      },
    ],
  },
  {
    title: 'Site Content',
    description: 'Control the public homepage, story, values, and partner-facing content.',
    items: [
      {
        key: 'main-banner',
        label: 'Main Banner',
        helper: 'Homepage hero/banner content.',
      },
      {
        key: 'dynamic-values',
        label: 'Dynamic Values',
        helper: 'Reusable text and public dynamic fields.',
      },
      {
        key: 'about-community',
        label: 'About Community',
        helper: 'Community mission and about-page content.',
      },
      {
        key: 'accomplishments',
        label: 'Accomplishments',
        helper: 'Milestones and impact statements.',
      },
      {
        key: 'news',
        label: 'News',
        helper: 'News updates shown publicly.',
      },
      {
        key: 'youtube-links',
        label: 'YouTube Links',
        helper: 'Featured video links.',
      },
      {
        key: 'associations',
        label: 'Associations',
        helper: 'Partner/community association logos.',
      },
      { key: 'site-analytics', label: 'Visitor Analytics', helper: 'Day, time, and section visit trends.' },
    ],
  },
  {
    title: 'Exam Simulations',
    description: 'Manage reusable school and professional practice exams and performance reporting.',
    items: [
      {
        key: 'exam-simulations',
        label: 'Exam Simulations',
        helper: 'Participation, attempts, scores, domain performance, and simulation settings.',
      },
    ],
  },
  {
    title: 'Events & Programs',
    description: 'Manage public activities, media, training, and summit records.',
    items: [
      {
        key: 'calendar-events',
        label: 'Calendar Events',
        helper: 'Add/edit normal UC calendar events.',
      },
      {
        key: 'event-registrations',
        label: 'Event Registrations',
        helper: 'Review native event RSVP/applied users.',
      },
      {
        key: 'community-meetups',
        label: 'Community Meetups',
        helper: 'City-center, library, and online public sessions.',
      },
      {
        key: 'meetup-registrations',
        label: 'Meetup Registrations',
        helper: 'Review RSVP/applied users for community meetups.',
      },
      {
        key: 'event-volunteers',
        label: 'Event Volunteers',
        helper: 'Approve service hours and issue verifiable volunteer certificates.',
      },
      {
        key: 'training-programs',
        label: 'Training Programs',
        helper: 'Training sessions displayed in calendar.',
      },
      {
        key: 'tech-summit-registrations',
        label: 'Tech Summit Registrations',
        helper: 'Tech Summit attendee records.',
      },
      {
        key: 'gallery-upload',
        label: 'Gallery Upload',
        helper: 'Community gallery photos.',
      },
      {
        key: 'event-images-upload',
        label: 'Event Images Upload',
        helper: 'Images attached to events.',
      },
    ],
  },
  {
    title: 'Operations',
    description: 'Admin-only support tools and communications.',
    items: [
      {
        key: 'help-needed-list',
        label: 'Help Needed List',
        helper: 'Manage community help requests.',
      },
      {
        key: 'user-management',
        label: 'User Management',
        helper: 'Manage UC users and roles.',
      },
      {
        key: 'email-communication',
        label: 'Email Communication',
        helper: 'Send or coordinate email communication.',
      },
    ],
  },
];

const adminItems = adminGroups.flatMap((group) =>
  group.items.map((item) => ({ ...item, groupTitle: group.title }))
);

const PunditApprovalTab = () => {
  const [punditRequests, setPunditRequests] = useState([]);
  const [punditLoading, setPunditLoading] = useState(true);
  const [actionId, setActionId] = useState(null);
  const token = localStorage.getItem('token');

  const fetchPunditRequests = useCallback(() => {
    setPunditLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/auth/pundit-registrations?status=pending_approval`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setPunditRequests(res.data))
      .catch((err) => {
        console.error('Error fetching pending pundit approvals', err);
        alert('Error fetching pending pundit approvals');
      })
      .finally(() => setPunditLoading(false));
  }, [token]);

  useEffect(() => {
    fetchPunditRequests();
  }, [fetchPunditRequests]);

  const updatePunditStatus = (id, action) => {
    setActionId(id);
    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/auth/pundit-registrations/${id}/${action}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        alert(action === 'approve' ? 'Pundit approved and email sent!' : 'Pundit registration rejected!');
        setPunditRequests((prev) => prev.filter((request) => request.id !== id));
      })
      .catch((err) => {
        console.error(`Error trying to ${action} pundit`, err);
        alert(err?.response?.data?.message || `Error trying to ${action} pundit`);
      })
      .finally(() => setActionId(null));
  };

  if (punditLoading) return <CircularProgress />;

  return (
    <Box>
      <Typography variant="h6">Pending Pundit Approvals</Typography>
      {punditRequests.length > 0 ? (
        punditRequests.map((request) => (
          <Box key={request.id} sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography><strong>Name:</strong> {request.first_name} {request.last_name}</Typography>
            <Typography><strong>Email:</strong> {request.email}</Typography>
            <Typography><strong>Mobile:</strong> {request.mobile}</Typography>
            <Typography><strong>Registered From:</strong> {request.source_user_type === 'udyog_connect' ? 'Udyog Connect user' : 'Pundit Purohit user'}</Typography>
            <Typography><strong>Status:</strong> {request.status}</Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
              <Button
                variant="contained"
                color="success"
                disabled={actionId === request.id}
                onClick={() => updatePunditStatus(request.id, 'approve')}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                disabled={actionId === request.id}
                onClick={() => updatePunditStatus(request.id, 'reject')}
              >
                Reject
              </Button>
            </Box>
          </Box>
        ))
      ) : (
        <Typography>No pending pundit approvals.</Typography>
      )}
    </Box>
  );
};

const SubscriptionAddonAdminTab = () => {
  const token = localStorage.getItem('token');
  const [plans, setPlans] = useState([]);
  const [addons, setAddons] = useState([]);
  const [planForm, setPlanForm] = useState({
    code: '',
    name: '',
    annualPrice: '',
    monthlyPoojaCredits: '',
    benefits: '',
    active: true,
    sortOrder: 0,
  });
  const [addonForm, setAddonForm] = useState({
    id: '',
    name: '',
    unitQuantity: 1,
    unitLabel: 'item',
    price: '',
    active: true,
    sortOrder: 0,
    discountType: 'none', discountValue: '', discountStartsAt: '', discountEndsAt: '', discountLabel: '',
  });

  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

  const fetchData = useCallback(() => {
    Promise.all([
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/subscription-plans?includeInactive=true`, { headers }),
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/addons?includeInactive=true`, { headers }),
    ])
      .then(([plansRes, addonsRes]) => {
        setPlans(plansRes.data);
        setAddons(addonsRes.data);
      })
      .catch((err) => {
        console.error('Error fetching plans/addons', err);
        alert('Unable to load subscription plans and addons');
      });
  }, [headers]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const savePlan = (e) => {
    e.preventDefault();
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/subscription-plans`, {
        ...planForm,
        annualPrice: Number(planForm.annualPrice),
        monthlyPoojaCredits: Number(planForm.monthlyPoojaCredits),
        benefits: planForm.benefits.split('\n').map((item) => item.trim()).filter(Boolean),
        sortOrder: Number(planForm.sortOrder),
      }, { headers })
      .then(() => {
        alert('Subscription plan saved');
        setPlanForm({ code: '', name: '', annualPrice: '', monthlyPoojaCredits: '', benefits: '', active: true, sortOrder: 0 });
        fetchData();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save plan'));
  };

  const saveAddon = (e) => {
    e.preventDefault();
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/addons`, {
        ...addonForm,
        id: addonForm.id || undefined,
        unitQuantity: Number(addonForm.unitQuantity),
        price: Number(addonForm.price),
        sortOrder: Number(addonForm.sortOrder),
        discountValue: Number(addonForm.discountValue) || 0,
      }, { headers })
      .then(() => {
        alert('Addon saved');
        setAddonForm({ id: '', name: '', unitQuantity: 1, unitLabel: 'item', price: '', active: true, sortOrder: 0, discountType: 'none', discountValue: '', discountStartsAt: '', discountEndsAt: '', discountLabel: '' });
        fetchData();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save addon'));
  };

  return (
    <Box sx={{ display: 'grid', gap: 3 }}>
      <Box>
        <Typography variant="h6">Subscription Plans</Typography>
        {plans.map((plan) => (
          <Box key={plan.code} sx={{ p: 2, my: 1, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography><strong>{plan.name}</strong> - ${plan.annualPrice}</Typography>
            <Typography>{plan.monthlyPoojaCredits} poojas/month | {plan.active ? 'Active' : 'Inactive'}</Typography>
            <Button size="small" onClick={() => setPlanForm({
              code: plan.code,
              name: plan.name,
              annualPrice: plan.annualPrice,
              monthlyPoojaCredits: plan.monthlyPoojaCredits,
              benefits: (plan.benefits || []).join('\n'),
              active: plan.active,
              sortOrder: plan.sortOrder,
            })}>Edit</Button>
          </Box>
        ))}
        <Box component="form" onSubmit={savePlan} sx={{ display: 'grid', gap: 1, maxWidth: 520, mt: 2 }}>
          <input placeholder="Code e.g. silver" value={planForm.code} onChange={(e) => setPlanForm({ ...planForm, code: e.target.value })} required />
          <input placeholder="Name" value={planForm.name} onChange={(e) => setPlanForm({ ...planForm, name: e.target.value })} required />
          <input placeholder="Annual price" type="number" value={planForm.annualPrice} onChange={(e) => setPlanForm({ ...planForm, annualPrice: e.target.value })} required />
          <input placeholder="Monthly free poojas" type="number" value={planForm.monthlyPoojaCredits} onChange={(e) => setPlanForm({ ...planForm, monthlyPoojaCredits: e.target.value })} required />
          <textarea placeholder="Benefits, one per line" value={planForm.benefits} onChange={(e) => setPlanForm({ ...planForm, benefits: e.target.value })} />
          <label><input type="checkbox" checked={planForm.active} onChange={(e) => setPlanForm({ ...planForm, active: e.target.checked })} /> Active</label>
          <input placeholder="Sort order" type="number" value={planForm.sortOrder} onChange={(e) => setPlanForm({ ...planForm, sortOrder: e.target.value })} />
          <Button type="submit" variant="contained">Save Plan</Button>
        </Box>
      </Box>

      <Box>
        <Typography variant="h6">Addons</Typography>
        {addons.map((addon) => (
          <Box key={addon.id} sx={{ p: 2, my: 1, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography><strong>{addon.name}</strong> - {addon.unitQuantity} {addon.unitLabel} / ${addon.price}</Typography>
            <Typography>{addon.active ? 'Active' : 'Inactive'}</Typography>
            <Button size="small" onClick={() => setAddonForm({
              id: addon.id,
              name: addon.name,
              unitQuantity: addon.unitQuantity,
              unitLabel: addon.unitLabel,
              price: addon.price,
              active: addon.active,
              sortOrder: addon.sortOrder,
              discountType: addon.discountType || 'none', discountValue: addon.discountValue || '', discountStartsAt: addon.discountStartsAt ? String(addon.discountStartsAt).slice(0, 16) : '', discountEndsAt: addon.discountEndsAt ? String(addon.discountEndsAt).slice(0, 16) : '', discountLabel: addon.discountLabel || '',
            })}>Edit</Button>
          </Box>
        ))}
        <Box component="form" onSubmit={saveAddon} sx={{ display: 'grid', gap: 1, maxWidth: 520, mt: 2 }}>
          <input placeholder="Addon name" value={addonForm.name} onChange={(e) => setAddonForm({ ...addonForm, name: e.target.value })} required />
          <input placeholder="Unit quantity" type="number" value={addonForm.unitQuantity} onChange={(e) => setAddonForm({ ...addonForm, unitQuantity: e.target.value })} />
          <input placeholder="Unit label" value={addonForm.unitLabel} onChange={(e) => setAddonForm({ ...addonForm, unitLabel: e.target.value })} />
          <input placeholder="Price" type="number" value={addonForm.price} onChange={(e) => setAddonForm({ ...addonForm, price: e.target.value })} required />
          <select value={addonForm.discountType} onChange={(e) => setAddonForm({ ...addonForm, discountType: e.target.value })}><option value="none">No discount</option><option value="percent">Percent off</option><option value="fixed">Fixed amount off</option></select>
          <input placeholder="Discount value" type="number" value={addonForm.discountValue} onChange={(e) => setAddonForm({ ...addonForm, discountValue: e.target.value })} />
          <input placeholder="Discount label" value={addonForm.discountLabel} onChange={(e) => setAddonForm({ ...addonForm, discountLabel: e.target.value })} />
          <input type="datetime-local" value={addonForm.discountStartsAt} onChange={(e) => setAddonForm({ ...addonForm, discountStartsAt: e.target.value })} />
          <input type="datetime-local" value={addonForm.discountEndsAt} onChange={(e) => setAddonForm({ ...addonForm, discountEndsAt: e.target.value })} />
          <label><input type="checkbox" checked={addonForm.active} onChange={(e) => setAddonForm({ ...addonForm, active: e.target.checked })} /> Active</label>
          <input placeholder="Sort order" type="number" value={addonForm.sortOrder} onChange={(e) => setAddonForm({ ...addonForm, sortOrder: e.target.value })} />
          <Button type="submit" variant="contained">Save Addon</Button>
        </Box>
      </Box>
    </Box>
  );
};

const emptyPoojaForm = {
  name: '',
  title: '',
  description: '',
  includedItems: '',
  punditCount: 1,
  significance: '',
  whyPerform: '',
  ritualProcess: '',
  itemsRequired: '',
  preparation: '',
  active: true,
  sortOrder: 0,
  pricingTiers: [{
    tierId: '',
    duration: '',
    price: '',
    label: '',
    actionDetails: '',
    discountType: 'none',
    discountValue: '',
    discountStartsAt: '',
    discountEndsAt: '',
    discountLabel: '',
    active: true,
    sortOrder: 1,
  }],
};

const buildPoojaForm = (pooja) => ({
  name: pooja?.name || '',
  title: pooja?.title || pooja?.name || '',
  description: pooja?.description || '',
  includedItems: (pooja?.includedItems || []).join('\n'),
  punditCount: pooja?.punditCount || 1,
  significance: pooja?.significance || '',
  whyPerform: (pooja?.whyPerform || []).join('\n'),
  ritualProcess: (pooja?.ritualProcess || []).join('\n'),
  itemsRequired: (pooja?.itemsRequired || []).join('\n'),
  preparation: pooja?.preparation || '',
  active: pooja?.active !== false,
  sortOrder: pooja?.sortOrder || 0,
  pricingTiers: (pooja?.pricingTiers || []).map((tier, index) => ({
    tierId: tier.tierId || `tier-${index + 1}`,
    duration: tier.duration || '',
    price: tier.price ?? '',
    label: tier.label || '',
    actionDetails: (tier.actions || []).join('\n'),
    discountType: tier.discountType || 'none',
    discountValue: tier.discountValue ?? '',
    discountStartsAt: tier.discountStartsAt ? String(tier.discountStartsAt).slice(0, 16) : '',
    discountEndsAt: tier.discountEndsAt ? String(tier.discountEndsAt).slice(0, 16) : '',
    discountLabel: tier.discountLabel || '',
    active: tier.active !== false,
    sortOrder: tier.sortOrder || index + 1,
  })),
});

const textareaToList = (value) => (
  String(value || '')
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean)
);

const discountPreviewPrice = (price, discountType, discountValue) => {
  const original = Math.max(Number(price) || 0, 0);
  const value = Math.max(Number(discountValue) || 0, 0);
  if (discountType === 'percent') return Math.max(original - (original * Math.min(value, 100) / 100), 0);
  if (discountType === 'fixed') return Math.max(original - value, 0);
  return original;
};

const defaultHeroSettings = {
  badge: 'Divine Services at Your Doorstep',
  headline: 'Experience the Essence of',
  highlight: 'Vedic Rituals',
  subtitle: 'Book verified Pundits and high-quality Pooja essentials with ease.',
  trustLine: 'Our Pandits are highly qualified industry leaders. We perform Poojas with passion and devotion—not as a profession.',
  backgroundImage: '',
  storedBackgroundImage: '',
  backgroundImages: [],
  storedBackgroundImages: [],
  stats: [
    { value: '50+', label: 'Verified Pundits' },
    { value: '100+', label: 'Pooja Items' },
    { value: '20+', label: 'Happy Devotees' },
  ],
};

const PoojaOrdersAdminTab = () => {
  const apiBase = process.env.REACT_APP_API_BASE_URL;
  const headers = useMemo(() => ({ Authorization: `Bearer ${localStorage.getItem('token')}` }), []);
  const [orders, setOrders] = useState([]);
  const [filters, setFilters] = useState({ search: '', status: '', from: '', to: '' });
  const [loading, setLoading] = useState(false);

  const fetchOrders = useCallback(() => {
    setLoading(true);
    axios.get(`${apiBase}/api/admin/punditpurohit/orders`, { headers, params: filters })
      .then((res) => setOrders(Array.isArray(res.data) ? res.data : []))
      .catch((err) => alert(err?.response?.data?.message || 'Unable to load Pooja orders'))
      .finally(() => setLoading(false));
  }, [apiBase, filters, headers]);

  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  const exportOrders = () => {
    const rows = orders.map((order) => [
      order.orderId,
      order.createdAt ? new Date(order.createdAt).toLocaleString() : '',
      order.customerName,
      order.customerEmail,
      order.status,
      order.paymentStatus,
      order.finalTotal,
      (order.items || []).map((item) => `${item.name} (${item.bookingDate || ''} ${item.bookingTime || ''})`).join(' | '),
      order.address?.address || '',
      order.address?.city || '',
      order.address?.state || '',
      order.address?.postalCode || order.address?.postal_code || '',
      order.bookingReason,
    ]);
    const csv = [['Order', 'Created', 'Customer', 'Email', 'Status', 'Payment', 'Total', 'Items', 'Address', 'City', 'State', 'ZIP', 'Reason'], ...rows]
      .map((row) => row.map((value) => `"${String(value ?? '').replace(/"/g, '""')}"`).join(','))
      .join('\n');
    const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a'); link.href = url; link.download = 'pooja-orders.csv'; link.click(); URL.revokeObjectURL(url);
  };

  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
        <Box><Typography variant="h6">Pooja Orders</Typography><Typography variant="body2">{orders.length} order{orders.length === 1 ? '' : 's'} found. Search by customer, email, order, or pooja.</Typography></Box>
        <Box sx={{ display: 'flex', gap: 1 }}><Button size="small" variant="outlined" onClick={fetchOrders}>Refresh</Button><Button size="small" variant="outlined" onClick={exportOrders} disabled={!orders.length}>Export CSV</Button></Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr 1fr' }, gap: 1 }}>
        <TextField size="small" label="Search" placeholder="Order, customer, email, pooja" value={filters.search} onChange={(e) => setFilters({ ...filters, search: e.target.value })} />
        <TextField size="small" select label="Status" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}><MenuItem value="">All statuses</MenuItem><MenuItem value="booked">Booked</MenuItem><MenuItem value="partially_reserved">Partially reserved</MenuItem><MenuItem value="reserved">Reserved</MenuItem><MenuItem value="cancelled">Cancelled</MenuItem></TextField>
        <TextField size="small" type="date" label="From" value={filters.from} onChange={(e) => setFilters({ ...filters, from: e.target.value })} InputLabelProps={{ shrink: true }} />
        <TextField size="small" type="date" label="To" value={filters.to} onChange={(e) => setFilters({ ...filters, to: e.target.value })} InputLabelProps={{ shrink: true }} />
      </Box>
      <Box sx={{ overflowX: 'auto', border: '1px solid #dbe5f2', borderRadius: 1 }}>
        <table className="pp-admin-orders-table"><thead><tr><th>Order / created</th><th>Customer</th><th>Pooja schedule</th><th>Address</th><th>Status</th><th>Total</th></tr></thead><tbody>
          {orders.map((order) => <tr key={order.id}><td><strong>{order.orderId}</strong><small>{order.createdAt ? new Date(order.createdAt).toLocaleString() : ''}</small></td><td><strong>{order.customerName}</strong><small>{order.customerEmail}</small></td><td>{(order.items || []).map((item) => <div key={`${order.id}-${item.id}`}><strong>{item.name}</strong><small>{item.bookingDate || 'Date pending'} {item.bookingTime || ''}</small></div>)}<small className="order-reason">Reason: {order.bookingReason || '—'}</small></td><td>{order.address?.address || '—'}<small>{[order.address?.city, order.address?.state, order.address?.postalCode || order.address?.postal_code].filter(Boolean).join(', ')}</small></td><td><span className="order-status">{order.status}</span><small>{order.paymentStatus}</small></td><td>${Number(order.finalTotal || 0).toFixed(2)}</td></tr>)}
          {!loading && !orders.length && <tr><td colSpan="6">No Pooja orders found.</td></tr>}
        </tbody></table>
      </Box>
    </Box>
  );
};

const PoojaTestimonialsAdminTab = () => {
  const apiBase = process.env.REACT_APP_API_BASE_URL;
  const headers = useMemo(() => ({ Authorization: `Bearer ${localStorage.getItem('token')}` }), []);
  const [status, setStatus] = useState('pending');
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionId, setActionId] = useState(null);

  const fetchTestimonials = useCallback(() => {
    setLoading(true);
    axios.get(`${apiBase}/api/admin/punditpurohit/testimonials`, { headers, params: { status } })
      .then((res) => setTestimonials(Array.isArray(res.data) ? res.data : []))
      .catch((err) => alert(err?.response?.data?.message || 'Unable to load devotee testimonials.'))
      .finally(() => setLoading(false));
  }, [apiBase, headers, status]);

  useEffect(() => { fetchTestimonials(); }, [fetchTestimonials]);

  const review = (id, nextStatus) => {
    setActionId(id);
    axios.put(`${apiBase}/api/admin/punditpurohit/testimonials/${id}`, { status: nextStatus }, { headers })
      .then(() => fetchTestimonials())
      .catch((err) => alert(err?.response?.data?.message || 'Unable to update testimonial.'))
      .finally(() => setActionId(null));
  };

  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="h6">Devotee Testimonials</Typography>
          <Typography variant="body2">Only approved testimonials are displayed on the Divine Rituals public page.</Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <TextField select size="small" label="Status" value={status} onChange={(event) => setStatus(event.target.value)} sx={{ minWidth: 150 }}>
            <MenuItem value="pending">Pending review</MenuItem>
            <MenuItem value="approved">Approved</MenuItem>
            <MenuItem value="rejected">Rejected</MenuItem>
          </TextField>
          <Button size="small" variant="outlined" onClick={fetchTestimonials} disabled={loading}>Refresh</Button>
        </Box>
      </Box>

      {loading ? <CircularProgress size={28} /> : testimonials.length === 0 ? (
        <Box sx={{ p: 3, border: '1px dashed #b6c4d8', borderRadius: 2 }}>
          <Typography>No {status} testimonials found.</Typography>
        </Box>
      ) : testimonials.map((testimonial) => (
        <Box key={testimonial.id} sx={{ p: 2.25, border: '1px solid #dbe5f2', borderRadius: 2, background: '#fff' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
            <Box>
              <Typography><strong>{testimonial.displayName}</strong></Typography>
              <Typography variant="body2" color="text.secondary">Booking: {testimonial.orderNumber} · Submitted: {new Date(testimonial.createdAt).toLocaleString()}</Typography>
              <Typography variant="body2" color="text.secondary">Contact: {testimonial.userEmail}</Typography>
            </Box>
            <Typography sx={{ textTransform: 'capitalize', fontWeight: 800 }}>{testimonial.status}</Typography>
          </Box>
          <Typography sx={{ mt: 1.5, whiteSpace: 'pre-wrap' }}>{testimonial.testimonial}</Typography>
          {status === 'pending' && (
            <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
              <Button size="small" variant="contained" color="success" disabled={actionId === testimonial.id} onClick={() => review(testimonial.id, 'approved')}>Approve</Button>
              <Button size="small" variant="outlined" color="error" disabled={actionId === testimonial.id} onClick={() => review(testimonial.id, 'rejected')}>Reject</Button>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

const PoojaManagementAdminTab = () => {
  const token = localStorage.getItem('token');
  const apiBase = process.env.REACT_APP_API_BASE_URL;
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);
  const [poojas, setPoojas] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [isCreatingPooja, setIsCreatingPooja] = useState(false);
  const [detailForm, setDetailForm] = useState(emptyPoojaForm);
  const [copiedFromPoojaName, setCopiedFromPoojaName] = useState('');
  const [copiedImageLists, setCopiedImageLists] = useState(null);
  const [uploadType, setUploadType] = useState('images');
  const [files, setFiles] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(0);
  const [loadingImages, setLoadingImages] = useState(true);
  const [saving, setSaving] = useState(false);
  const [heroForm, setHeroForm] = useState(defaultHeroSettings);
  const [publicCardForm, setPublicCardForm] = useState(null);
  const [heroFiles, setHeroFiles] = useState([]);
  const [heroFileInputKey, setHeroFileInputKey] = useState(0);
  const [heroPreviewErrors, setHeroPreviewErrors] = useState({});
  const [heroFilePreviews, setHeroFilePreviews] = useState([]);
  const [checkoutSettings, setCheckoutSettings] = useState({
    paymentGatewayEnabled: false,
    subscriptionFlowEnabled: false,
  });
  const [prasadamItems, setPrasadamItems] = useState([]);
  const [serviceAreas, setServiceAreas] = useState([]);
  const [serviceAreaForm, setServiceAreaForm] = useState({ city: '', state: 'GA', postalCodes: '', active: true });
  const [serviceAreaLoading, setServiceAreaLoading] = useState(false);
  const [prasadamForm, setPrasadamForm] = useState({
    id: '',
    name: '',
    description: '',
    price: '',
    active: true,
    sortOrder: 0,
    discountType: 'none',
    discountValue: '',
    discountStartsAt: '',
    discountEndsAt: '',
    discountLabel: '',
  });

  const selectedPooja = poojas.find((pooja) => pooja.id === selectedId);
  const getImageItems = (storedUrls = [], previewUrls = []) => (
    storedUrls.map((storedUrl, index) => ({
      storedUrl,
      previewUrl: previewUrls[index] || resolvePunditImageUrl(storedUrl),
    }))
  );

  const fetchPoojas = useCallback((preferredId = '') => {
    setLoadingImages(true);
    axios
      .get(`${apiBase}/api/admin/punditpurohit/poojas`, { headers })
      .then((res) => {
        const nextPoojas = res.data || [];
        setPoojas(nextPoojas);
        const nextSelectedId = preferredId || nextPoojas[0]?.id || '';
        setSelectedId(nextSelectedId);
        setIsCreatingPooja(false);
        const selected = nextPoojas.find((pooja) => pooja.id === nextSelectedId) || nextPoojas[0];
        setDetailForm(selected ? buildPoojaForm(selected) : emptyPoojaForm);
      })
      .catch((err) => {
        console.error('Error fetching pooja images', err);
        alert(err?.response?.data?.message || 'Unable to load pooja images');
      })
      .finally(() => setLoadingImages(false));
  }, [apiBase, headers]);

  const fetchHeroSettings = useCallback(() => {
    axios
      .get(`${apiBase}/api/admin/punditpurohit/hero`, { headers })
      .then((res) => {
        setHeroForm({ ...defaultHeroSettings, ...res.data });
        setHeroPreviewErrors({});
      })
      .catch((err) => {
        console.error('Error fetching hero settings', err);
        alert(err?.response?.data?.message || 'Unable to load hero settings');
      });
  }, [apiBase, headers]);

  useEffect(() => {
    const previews = heroFiles.map((file) => ({ name: file.name, url: URL.createObjectURL(file) }));
    setHeroFilePreviews(previews);
    return () => previews.forEach((preview) => URL.revokeObjectURL(preview.url));
  }, [heroFiles]);

  const fetchPrasadamItems = useCallback(() => {
    axios
      .get(`${apiBase}/api/admin/punditpurohit/prasadam`, { headers })
      .then((res) => setPrasadamItems(Array.isArray(res.data) ? res.data : []))
      .catch((err) => {
        console.error('Error fetching prasadam items', err);
        alert(err?.response?.data?.message || 'Unable to load prasadam items');
      });
  }, [apiBase, headers]);

  const fetchCheckoutSettings = useCallback(() => {
    axios
      .get(`${apiBase}/api/admin/punditpurohit/checkout-settings`, { headers })
      .then((res) => setCheckoutSettings({
        paymentGatewayEnabled: Boolean(res.data?.paymentGatewayEnabled),
        subscriptionFlowEnabled: Boolean(res.data?.subscriptionFlowEnabled),
      }))
      .catch((err) => {
        console.error('Error fetching checkout settings', err);
        alert(err?.response?.data?.message || 'Unable to load checkout settings');
      });
  }, [apiBase, headers]);

  const fetchPublicCardSettings = useCallback(() => {
    axios
      .get(`${apiBase}/api/admin/punditpurohit/public-cards`, { headers })
      .then((res) => setPublicCardForm(res.data || null))
      .catch((err) => {
        console.error('Error fetching public PP card settings', err);
        alert(err?.response?.data?.message || 'Unable to load public card content');
      });
  }, [apiBase, headers]);

  const fetchServiceAreas = useCallback(() => {
    axios
      .get(`${apiBase}/api/admin/punditpurohit/service-areas`, { headers })
      .then((res) => setServiceAreas(Array.isArray(res.data) ? res.data : []))
      .catch((err) => alert(err?.response?.data?.message || 'Unable to load service areas'));
  }, [apiBase, headers]);

  useEffect(() => {
    fetchPoojas();
    fetchHeroSettings();
    fetchPrasadamItems();
    fetchCheckoutSettings();
    fetchPublicCardSettings();
    fetchServiceAreas();
  }, [fetchPoojas, fetchHeroSettings, fetchPrasadamItems, fetchCheckoutSettings, fetchPublicCardSettings, fetchServiceAreas]);

  const lookupServiceAreaZips = () => {
    if (!serviceAreaForm.city.trim() || !serviceAreaForm.state) {
      alert('Select a state and enter a city first.');
      return;
    }
    setServiceAreaLoading(true);
    axios
      .get(`${apiBase}/api/punditpurohit/service-area/lookup`, { params: { city: serviceAreaForm.city, state: serviceAreaForm.state } })
      .then((res) => setServiceAreaForm((prev) => ({ ...prev, postalCodes: (res.data?.postalCodes || []).join(', ') })))
      .catch((err) => alert(err?.response?.data?.message || 'Unable to find ZIP codes for that city'))
      .finally(() => setServiceAreaLoading(false));
  };

  const saveServiceArea = (event) => {
    event.preventDefault();
    setServiceAreaLoading(true);
    axios
      .post(`${apiBase}/api/admin/punditpurohit/service-areas`, {
        ...serviceAreaForm,
        postalCodes: serviceAreaForm.postalCodes.split(/[\s,]+/).filter(Boolean),
      }, { headers })
      .then(() => { alert('Service area saved'); setServiceAreaForm({ city: '', state: 'GA', postalCodes: '', active: true }); fetchServiceAreas(); })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save service area'))
      .finally(() => setServiceAreaLoading(false));
  };

  const removeServiceArea = (id) => {
    if (!window.confirm('Remove this service area?')) return;
    axios
      .delete(`${apiBase}/api/admin/punditpurohit/service-areas/${id}`, { headers })
      .then(() => fetchServiceAreas())
      .catch((err) => alert(err?.response?.data?.message || 'Unable to remove service area'));
  };

  const selectPooja = (poojaId) => {
    const pooja = poojas.find((item) => item.id === poojaId);
    setSelectedId(poojaId);
    setIsCreatingPooja(false);
    setDetailForm(pooja ? buildPoojaForm(pooja) : emptyPoojaForm);
    setCopiedFromPoojaName('');
    setCopiedImageLists(null);
    setFiles([]);
    setFileInputKey((key) => key + 1);
  };

  const startNewPooja = () => {
    setSelectedId('');
    setIsCreatingPooja(true);
    setDetailForm(emptyPoojaForm);
    setCopiedFromPoojaName('');
    setCopiedImageLists(null);
    setFiles([]);
    setFileInputKey((key) => key + 1);
  };

  const duplicateSelectedPooja = () => {
    if (!selectedPooja) return;

    const sourceForm = buildPoojaForm(selectedPooja);
    const sourceName = selectedPooja.name || 'Pooja';
    const sourceTitle = selectedPooja.title || sourceName;

    setSelectedId('');
    setIsCreatingPooja(true);
    setDetailForm({
      ...sourceForm,
      name: `${sourceName} (Copy)`,
      title: `${sourceTitle} (Copy)`,
    });
    setCopiedFromPoojaName(sourceName);
    setCopiedImageLists({
      images: [...(selectedPooja.storedImages || [])],
      gallery: [...(selectedPooja.storedGallery || [])],
    });
    setFiles([]);
    setFileInputKey((key) => key + 1);
  };

  const updateDetailField = (field, value) => {
    setDetailForm((prev) => ({ ...prev, [field]: value }));
  };

  const updateTier = (index, field, value) => {
    setDetailForm((prev) => ({
      ...prev,
      pricingTiers: prev.pricingTiers.map((tier, tierIndex) => (
        tierIndex === index ? { ...tier, [field]: value } : tier
      )),
    }));
  };

  const addTier = () => {
    setDetailForm((prev) => ({
      ...prev,
      pricingTiers: [
        ...prev.pricingTiers,
        {
          tierId: '',
          duration: '',
          price: '',
          label: '',
          actionDetails: '',
          discountType: 'none',
          discountValue: '',
          discountStartsAt: '',
          discountEndsAt: '',
          discountLabel: '',
          active: true,
          sortOrder: prev.pricingTiers.length + 1,
        },
      ],
    }));
  };

  const removeTier = (index) => {
    setDetailForm((prev) => ({
      ...prev,
      pricingTiers: prev.pricingTiers.filter((tier, tierIndex) => tierIndex !== index),
    }));
  };

  const savePoojaDetails = (e) => {
    e.preventDefault();
    if (!isCreatingPooja && !selectedId) return;

    setSaving(true);
    const request = isCreatingPooja
      ? axios.post
      : axios.put;
    const url = isCreatingPooja
      ? `${apiBase}/api/admin/punditpurohit/poojas`
      : `${apiBase}/api/admin/punditpurohit/poojas/${selectedId}`;

    request(url, {
        ...detailForm,
        includedItems: textareaToList(detailForm.includedItems),
        whyPerform: textareaToList(detailForm.whyPerform),
        ritualProcess: textareaToList(detailForm.ritualProcess),
        itemsRequired: textareaToList(detailForm.itemsRequired),
        punditCount: Number(detailForm.punditCount),
        sortOrder: Number(detailForm.sortOrder),
        pricingTiers: detailForm.pricingTiers.map((tier, index) => ({
          ...tier,
          actions: textareaToList(tier.actionDetails),
          price: Number(tier.price),
          sortOrder: Number(tier.sortOrder) || index + 1,
          discountValue: Number(tier.discountValue) || 0,
        })),
      }, { headers })
      .then((res) => {
        const createdPoojaId = isCreatingPooja ? res.data?.id : '';
        if (!createdPoojaId || !copiedImageLists) return res;

        return axios
          .put(`${apiBase}/api/admin/punditpurohit/poojas/${createdPoojaId}/images`, copiedImageLists, { headers })
          .then(() => res)
          .catch((err) => {
            console.error('Copying pooja image references failed:', err);
            alert('The pooja copy was created, but its image references could not be copied. You can add images from the new pooja after saving.');
            return res;
          });
      })
      .then((res) => {
        alert(isCreatingPooja
          ? (copiedFromPoojaName ? 'Pooja copy created with the existing image references. Review it and save any changes.' : 'Pooja created. You can upload images now.')
          : 'Pooja details saved');
        fetchPoojas(res.data?.id || selectedId);
      })
      .catch((err) => alert(err?.response?.data?.message || (isCreatingPooja ? 'Unable to create pooja' : 'Unable to save pooja details')))
      .finally(() => setSaving(false));
  };

  const uploadImages = () => {
    if (!selectedId || files.length === 0) return;

    const formData = new FormData();
    formData.append('imageType', uploadType);
    files.forEach((file) => formData.append('images', file));

    setSaving(true);
    axios
      .post(`${apiBase}/api/admin/punditpurohit/poojas/${selectedId}/images/upload`, formData, {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        alert('Images uploaded');
        setFiles([]);
        setFileInputKey((key) => key + 1);
        fetchPoojas(selectedId);
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to upload images'))
      .finally(() => setSaving(false));
  };

  const removeImage = (imageType, imageUrl) => {
    if (!selectedId || !imageUrl) return;

    setSaving(true);
    axios
      .delete(`${apiBase}/api/admin/punditpurohit/poojas/${selectedId}/images`, {
        headers,
        data: { imageType, imageUrl },
      })
      .then(() => {
        alert('Image removed');
        fetchPoojas(selectedId);
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to remove image'))
      .finally(() => setSaving(false));
  };

  const updateHeroField = (field, value) => {
    setHeroForm((prev) => ({ ...prev, [field]: value }));
  };

  const updateHeroStat = (index, field, value) => {
    setHeroForm((prev) => ({
      ...prev,
      stats: prev.stats.map((stat, statIndex) => (
        statIndex === index ? { ...stat, [field]: value } : stat
      )),
    }));
  };

  const saveHeroSettings = (e) => {
    e.preventDefault();
    setSaving(true);
    axios
      .put(`${apiBase}/api/admin/punditpurohit/hero`, heroForm, { headers })
      .then(() => {
        alert('Hero settings saved');
        fetchHeroSettings();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save hero settings'))
      .finally(() => setSaving(false));
  };

  const updatePublicCardField = (section, field, value) => {
    setPublicCardForm((current) => ({
      ...current,
      [section]: { ...(current?.[section] || {}), [field]: value },
    }));
  };

  const savePublicCardSettings = (e) => {
    e.preventDefault();
    if (!publicCardForm) return;
    setSaving(true);
    axios
      .put(`${apiBase}/api/admin/punditpurohit/public-cards`, publicCardForm, { headers })
      .then((res) => {
        setPublicCardForm(res.data?.settings || publicCardForm);
        alert('Public card content saved');
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save public card content'))
      .finally(() => setSaving(false));
  };

  const uploadHeroImage = () => {
    if (!heroFiles.length) return;

    const formData = new FormData();
    heroFiles.forEach((file) => formData.append('images', file));

    setSaving(true);
    axios
      .post(`${apiBase}/api/admin/punditpurohit/hero/image`, formData, {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        alert('Hero banner uploaded');
        setHeroFiles([]);
        setHeroPreviewErrors({});
        setHeroFileInputKey((key) => key + 1);
        setHeroForm((prev) => ({
          ...prev,
          backgroundImage: res.data.backgroundImage || prev.backgroundImage,
          storedBackgroundImage: res.data.storedBackgroundImage || prev.storedBackgroundImage,
          backgroundImages: res.data.backgroundImages || prev.backgroundImages,
          storedBackgroundImages: res.data.storedBackgroundImages || prev.storedBackgroundImages,
        }));
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to upload hero banner'))
      .finally(() => setSaving(false));
  };

  const removeHeroImage = (storedImageUrl) => {
    if (!storedImageUrl || !window.confirm('Remove this hero slide? This only removes the selected slide from the carousel.')) return;
    setSaving(true);
    axios
      .delete(`${apiBase}/api/admin/punditpurohit/hero/image`, { headers, data: { imageUrl: storedImageUrl } })
      .then(() => {
        alert('Hero slide removed');
        fetchHeroSettings();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to remove hero slide'))
      .finally(() => setSaving(false));
  };

  const resetPrasadamForm = () => {
    setPrasadamForm({
      id: '',
      name: '',
      description: '',
      price: '',
      active: true,
      sortOrder: 0,
      discountType: 'none',
      discountValue: '',
      discountStartsAt: '',
      discountEndsAt: '',
      discountLabel: '',
    });
  };

  const savePrasadamItem = (event) => {
    event.preventDefault();
    setSaving(true);
    axios
      .post(`${apiBase}/api/admin/punditpurohit/prasadam`, {
        ...prasadamForm,
        price: Number(prasadamForm.price),
        sortOrder: Number(prasadamForm.sortOrder),
        discountValue: Number(prasadamForm.discountValue) || 0,
      }, { headers })
      .then(() => {
        alert(prasadamForm.id ? 'Prasadam item saved' : 'Prasadam item added');
        resetPrasadamForm();
        fetchPrasadamItems();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save prasadam item'))
      .finally(() => setSaving(false));
  };

  const editPrasadamItem = (item) => {
    setPrasadamForm({
      id: item.id,
      name: item.name || '',
      description: item.description || '',
      price: item.price || '',
      active: Boolean(item.active),
      sortOrder: item.sortOrder || 0,
      discountType: item.discountType || 'none',
      discountValue: item.discountValue ?? '',
      discountStartsAt: item.discountStartsAt ? String(item.discountStartsAt).slice(0, 16) : '',
      discountEndsAt: item.discountEndsAt ? String(item.discountEndsAt).slice(0, 16) : '',
      discountLabel: item.discountLabel || '',
    });
  };

  const deletePrasadamItem = (itemId) => {
    if (!window.confirm('Remove this prasadam item?')) return;
    setSaving(true);
    axios
      .delete(`${apiBase}/api/admin/punditpurohit/prasadam/${itemId}`, { headers })
      .then(() => {
        alert('Prasadam item removed');
        if (prasadamForm.id === itemId) resetPrasadamForm();
        fetchPrasadamItems();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to remove prasadam item'))
      .finally(() => setSaving(false));
  };

  const saveCheckoutSettings = (event) => {
    event.preventDefault();
    setSaving(true);
    axios
      .put(`${apiBase}/api/admin/punditpurohit/checkout-settings`, checkoutSettings, { headers })
      .then((res) => {
        setCheckoutSettings({
          paymentGatewayEnabled: Boolean(res.data?.paymentGatewayEnabled),
          subscriptionFlowEnabled: Boolean(res.data?.subscriptionFlowEnabled),
        });
        alert('Checkout settings saved');
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to save checkout settings'))
      .finally(() => setSaving(false));
  };

  if (loadingImages) return <CircularProgress />;

  return (
    <Box sx={{ display: 'grid', gap: 3, maxWidth: 980 }}>
      <Typography variant="h6">Pooja Management</Typography>

      <Box component="form" onSubmit={saveHeroSettings} sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
        <Typography variant="subtitle1">Main Banner</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
          <TextField label="Badge text" value={heroForm.badge} onChange={(e) => updateHeroField('badge', e.target.value)} />
          <TextField label="Highlighted headline" value={heroForm.highlight} onChange={(e) => updateHeroField('highlight', e.target.value)} />
        </Box>
        <TextField label="Headline" value={heroForm.headline} onChange={(e) => updateHeroField('headline', e.target.value)} />
        <TextField label="Subtitle" value={heroForm.subtitle} onChange={(e) => updateHeroField('subtitle', e.target.value)} multiline minRows={2} />
        <TextField label="Trust / devotion line" value={heroForm.trustLine} onChange={(e) => updateHeroField('trustLine', e.target.value)} multiline minRows={2} helperText="Shown prominently on the public Divine Rituals landing page." />

        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 1 }}>
          {(heroForm.stats || []).map((stat, index) => (
            <Box key={index} sx={{ display: 'grid', gap: 1 }}>
              <TextField label={`Stat ${index + 1} value`} value={stat.value} onChange={(e) => updateHeroStat(index, 'value', e.target.value)} />
              <TextField label={`Stat ${index + 1} label`} value={stat.label} onChange={(e) => updateHeroStat(index, 'label', e.target.value)} />
            </Box>
          ))}
        </Box>

        {heroForm.backgroundImage && (
          <Box sx={{ border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden', maxWidth: 520 }}>
            <img src={heroForm.backgroundImage} alt="Hero banner preview" style={{ width: '100%', height: 180, objectFit: 'cover', display: 'block' }} />
          </Box>
        )}
        {(heroForm.backgroundImages || []).length > 0 && (
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {heroForm.backgroundImages.map((image, index) => (
              <Box key={`${image}-${index}`} sx={{ width: 150, border: '1px solid #dbe5f2', borderRadius: 1, overflow: 'hidden', background: '#f7f9fc' }}>
                {!heroPreviewErrors[index] && <img src={image} alt={`Hero slide ${index + 1}`} onLoad={() => setHeroPreviewErrors((current) => ({ ...current, [index]: false }))} onError={() => setHeroPreviewErrors((current) => ({ ...current, [index]: true }))} style={{ width: '100%', height: 72, objectFit: 'contain', display: 'block' }} />}
                {heroPreviewErrors[index] && <Typography variant="caption" color="error" sx={{ minHeight: 72, px: 1, py: 1, display: 'block' }}>Image unavailable. Remove this slide and upload the image again.</Typography>}
                <Typography variant="caption" sx={{ display: 'block', p: 0.75 }}>Slide {index + 1}</Typography>
                <Button type="button" size="small" color="error" disabled={saving} onClick={() => removeHeroImage(heroForm.storedBackgroundImages?.[index])}>Remove</Button>
              </Box>
            ))}
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          <input
            key={heroFileInputKey}
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => setHeroFiles(Array.from(e.target.files || []))}
          />
          <Button type="button" variant="outlined" onClick={uploadHeroImage} disabled={saving || !heroFiles.length}>
            Upload Banner Images
          </Button>
        </Box>
        {heroFilePreviews.length > 0 && (
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {heroFilePreviews.map((preview) => (
              <Box key={preview.url} sx={{ width: 150, border: '1px dashed #87a8dc', borderRadius: 1, overflow: 'hidden', background: '#f8fbff' }}>
                <img src={preview.url} alt={`Selected banner: ${preview.name}`} style={{ width: '100%', height: 72, objectFit: 'contain', display: 'block' }} />
                <Typography variant="caption" sx={{ display: 'block', px: 0.75, py: 0.5, wordBreak: 'break-word' }}>Ready to upload: {preview.name}</Typography>
              </Box>
            ))}
          </Box>
        )}
        <Button type="submit" variant="outlined" size="small" sx={{ width: 'fit-content' }} disabled={saving}>
          Save Banner Text
        </Button>
      </Box>

      {publicCardForm && (
        <Box component="form" onSubmit={savePublicCardSettings} sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #cfe0f6', borderRadius: 2, background: '#fbfdff' }}>
          <Box>
            <Typography variant="subtitle1">Public Card Content</Typography>
            <Typography variant="body2" color="text.secondary">All public text for the Pandit & Seva recruitment cards and custom-pooja contact card. Layout and colors stay in CSS; this wording is saved in the database.</Typography>
          </Box>

          <Box sx={{ display: 'grid', gap: 1.25, p: 1.5, border: '1px solid #dbe5f2', borderRadius: 2 }}>
            <Typography variant="subtitle2">Top Pandit & Seva recruitment card</Typography>
            <TextField label="Badge" value={publicCardForm.providerPrimary?.badge || ''} onChange={(e) => updatePublicCardField('providerPrimary', 'badge', e.target.value)} />
            <TextField label="Heading" value={publicCardForm.providerPrimary?.heading || ''} onChange={(e) => updatePublicCardField('providerPrimary', 'heading', e.target.value)} />
            <TextField label="Message" value={publicCardForm.providerPrimary?.body || ''} onChange={(e) => updatePublicCardField('providerPrimary', 'body', e.target.value)} multiline minRows={3} />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 1.25 }}>
              <TextField label="Button label" value={publicCardForm.providerPrimary?.primaryButton || ''} onChange={(e) => updatePublicCardField('providerPrimary', 'primaryButton', e.target.value)} />
              <TextField label="Expectation note" value={publicCardForm.providerPrimary?.disclaimer || ''} onChange={(e) => updatePublicCardField('providerPrimary', 'disclaimer', e.target.value)} />
            </Box>
          </Box>

          <Box sx={{ display: 'grid', gap: 1.25, p: 1.5, border: '1px solid #dbe5f2', borderRadius: 2 }}>
            <Typography variant="subtitle2">Custom pooja contact card</Typography>
            <TextField label="Badge" value={publicCardForm.customPooja?.badge || ''} onChange={(e) => updatePublicCardField('customPooja', 'badge', e.target.value)} />
            <TextField label="Heading" value={publicCardForm.customPooja?.heading || ''} onChange={(e) => updatePublicCardField('customPooja', 'heading', e.target.value)} />
            <TextField label="Message" value={publicCardForm.customPooja?.body || ''} onChange={(e) => updatePublicCardField('customPooja', 'body', e.target.value)} multiline minRows={3} />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 1.25 }}>
              <TextField label="Contact email" type="email" value={publicCardForm.customPooja?.email || ''} onChange={(e) => updatePublicCardField('customPooja', 'email', e.target.value)} />
              <TextField label="Contact action label" value={publicCardForm.customPooja?.actionLabel || ''} onChange={(e) => updatePublicCardField('customPooja', 'actionLabel', e.target.value)} />
            </Box>
          </Box>

          <Box sx={{ display: 'grid', gap: 1.25, p: 1.5, border: '1px solid #dbe5f2', borderRadius: 2 }}>
            <Typography variant="subtitle2">Lower Pandit & Seva banner</Typography>
            <TextField label="Badge" value={publicCardForm.providerCompact?.badge || ''} onChange={(e) => updatePublicCardField('providerCompact', 'badge', e.target.value)} />
            <TextField label="Heading" value={publicCardForm.providerCompact?.heading || ''} onChange={(e) => updatePublicCardField('providerCompact', 'heading', e.target.value)} />
            <TextField label="Message" value={publicCardForm.providerCompact?.body || ''} onChange={(e) => updatePublicCardField('providerCompact', 'body', e.target.value)} multiline minRows={2} />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 1.25 }}>
              <TextField label="Join button" value={publicCardForm.providerCompact?.primaryButton || ''} onChange={(e) => updatePublicCardField('providerCompact', 'primaryButton', e.target.value)} />
              <TextField label="Invite button" value={publicCardForm.providerCompact?.secondaryButton || ''} onChange={(e) => updatePublicCardField('providerCompact', 'secondaryButton', e.target.value)} />
              <TextField label="Expectation note" value={publicCardForm.providerCompact?.disclaimer || ''} onChange={(e) => updatePublicCardField('providerCompact', 'disclaimer', e.target.value)} />
            </Box>
          </Box>

          <Box sx={{ display: 'grid', gap: 1.25, p: 1.5, border: '1px solid #dbe5f2', borderRadius: 2 }}>
            <Typography variant="subtitle2">No-results provider invitation</Typography>
            <TextField label="Heading" value={publicCardForm.providerSearchInvitation?.heading || ''} onChange={(e) => updatePublicCardField('providerSearchInvitation', 'heading', e.target.value)} />
            <TextField label="Message" value={publicCardForm.providerSearchInvitation?.body || ''} onChange={(e) => updatePublicCardField('providerSearchInvitation', 'body', e.target.value)} multiline minRows={2} />
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 1.25 }}>
              <TextField label="Invite button" value={publicCardForm.providerSearchInvitation?.inviteButton || ''} onChange={(e) => updatePublicCardField('providerSearchInvitation', 'inviteButton', e.target.value)} />
              <TextField label="Register button" value={publicCardForm.providerSearchInvitation?.registerButton || ''} onChange={(e) => updatePublicCardField('providerSearchInvitation', 'registerButton', e.target.value)} />
            </Box>
          </Box>

          <Button type="submit" variant="contained" size="small" sx={{ width: 'fit-content' }} disabled={saving}>Save Public Card Content</Button>
        </Box>
      )}

      <Box component="form" onSubmit={saveServiceArea} sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #dbe5f2', borderRadius: 2, background: '#f8fbff' }}>
        <Typography variant="subtitle1">Service Coverage Areas</Typography>
        <Typography variant="body2">Select a state and city, then fetch the city ZIP codes automatically. Only saved active ZIP codes can be booked.</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '0.7fr 1fr auto' }, gap: 2 }}>
          <TextField select label="State" value={serviceAreaForm.state} onChange={(e) => setServiceAreaForm({ ...serviceAreaForm, state: e.target.value })}>
            {['AL', 'AZ', 'CA', 'CO', 'FL', 'GA', 'IL', 'MA', 'MD', 'MI', 'NC', 'NJ', 'NY', 'OH', 'PA', 'TN', 'TX', 'VA', 'WA'].map((state) => <MenuItem key={state} value={state}>{state}</MenuItem>)}
          </TextField>
          <TextField label="City" value={serviceAreaForm.city} onChange={(e) => setServiceAreaForm({ ...serviceAreaForm, city: e.target.value })} required />
          <Button type="button" variant="outlined" onClick={lookupServiceAreaZips} disabled={serviceAreaLoading}>{serviceAreaLoading ? 'Finding…' : 'Find ZIP codes'}</Button>
        </Box>
        <TextField label="ZIP codes" helperText="Review and edit the comma-separated ZIP codes before saving." value={serviceAreaForm.postalCodes} onChange={(e) => setServiceAreaForm({ ...serviceAreaForm, postalCodes: e.target.value })} required />
        <label><input type="checkbox" checked={serviceAreaForm.active} onChange={(e) => setServiceAreaForm({ ...serviceAreaForm, active: e.target.checked })} /> Active coverage</label>
        <Button type="submit" variant="outlined" size="small" sx={{ width: 'fit-content' }} disabled={serviceAreaLoading}>Save Service Area</Button>
        <Box sx={{ display: 'grid', gap: 1 }}>
          {serviceAreas.map((area) => (
            <Box key={area.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: 'wrap', p: 1.2, border: '1px solid #dbe5f2', borderRadius: 1, background: '#fff' }}>
              <Box><Typography variant="body1"><strong>{area.city}, {area.state}</strong> {area.active ? '· Active' : '· Inactive'}</Typography><Typography variant="body2">ZIPs: {(area.postalCodes || []).join(', ')}</Typography></Box>
              <Button type="button" size="small" color="error" onClick={() => removeServiceArea(area.id)}>Remove</Button>
            </Box>
          ))}
          {!serviceAreas.length && <Typography variant="body2">No service areas configured yet.</Typography>}
        </Box>
      </Box>

      <Box component="form" onSubmit={saveCheckoutSettings} sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
        <Typography variant="subtitle1">Checkout Settings</Typography>
        <label>
          <input
            type="checkbox"
            checked={checkoutSettings.paymentGatewayEnabled}
            onChange={(e) => setCheckoutSettings((prev) => ({ ...prev, paymentGatewayEnabled: e.target.checked }))}
          /> Enable online payment gateway
        </label>
        <Typography variant="body2">
          {checkoutSettings.paymentGatewayEnabled
            ? 'Users will be redirected to Stripe during checkout.'
            : 'Users can place bookings without online payment.'}
        </Typography>
        <label>
          <input
            type="checkbox"
            checked={checkoutSettings.subscriptionFlowEnabled}
            onChange={(e) => setCheckoutSettings((prev) => ({ ...prev, subscriptionFlowEnabled: e.target.checked }))}
          /> Enable annual subscription flow
        </label>
        <Typography variant="body2">
          {checkoutSettings.subscriptionFlowEnabled
            ? 'Users will see subscription prompts and manage-subscription options.'
            : 'Subscription prompts and user-facing subscription pages will be hidden.'}
        </Typography>
        <Button type="submit" variant="outlined" size="small" sx={{ width: 'fit-content' }} disabled={saving}>
          Save Checkout Settings
        </Button>
      </Box>

      <Box component="form" onSubmit={savePrasadamItem} sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
        <Typography variant="subtitle1">Prasadam Rate Card</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 0.7fr 0.7fr' }, gap: 2 }}>
          <TextField label="Name" value={prasadamForm.name} onChange={(e) => setPrasadamForm({ ...prasadamForm, name: e.target.value })} required />
          <TextField label="Description" value={prasadamForm.description} onChange={(e) => setPrasadamForm({ ...prasadamForm, description: e.target.value })} />
          <TextField label="Original price" type="number" value={prasadamForm.price} onChange={(e) => setPrasadamForm({ ...prasadamForm, price: e.target.value })} inputProps={{ min: 0, step: '0.01' }} required />
          <TextField select label="Discount" value={prasadamForm.discountType} onChange={(e) => setPrasadamForm({ ...prasadamForm, discountType: e.target.value })}>
            <MenuItem value="none">No discount</MenuItem><MenuItem value="percent">Percent off</MenuItem><MenuItem value="fixed">Fixed amount off</MenuItem>
          </TextField>
          <TextField label="Discount value" type="number" value={prasadamForm.discountValue} onChange={(e) => setPrasadamForm({ ...prasadamForm, discountValue: e.target.value })} inputProps={{ min: 0, step: '0.01' }} />
          <TextField label="Sort order" type="number" value={prasadamForm.sortOrder} onChange={(e) => setPrasadamForm({ ...prasadamForm, sortOrder: e.target.value })} />
        </Box>
        {Number(prasadamForm.price) > 0 && prasadamForm.discountType !== 'none' && (
          <Typography variant="body2" className="pp-rate-preview">
            Rate card preview: <del>${Number(prasadamForm.price).toFixed(2)}</del> <strong>${discountPreviewPrice(prasadamForm.price, prasadamForm.discountType, prasadamForm.discountValue).toFixed(2)}</strong>
          </Typography>
        )}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 2 }}>
          <TextField label="Discount label" value={prasadamForm.discountLabel} onChange={(e) => setPrasadamForm({ ...prasadamForm, discountLabel: e.target.value })} placeholder="Opening offer" />
          <TextField label="Starts" type="datetime-local" value={prasadamForm.discountStartsAt} onChange={(e) => setPrasadamForm({ ...prasadamForm, discountStartsAt: e.target.value })} InputLabelProps={{ shrink: true }} />
          <TextField label="Ends" type="datetime-local" value={prasadamForm.discountEndsAt} onChange={(e) => setPrasadamForm({ ...prasadamForm, discountEndsAt: e.target.value })} InputLabelProps={{ shrink: true }} />
        </Box>
        <label>
          <input type="checkbox" checked={prasadamForm.active} onChange={(e) => setPrasadamForm({ ...prasadamForm, active: e.target.checked })} /> Active
        </label>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Button type="submit" variant="outlined" size="small" sx={{ width: 'fit-content' }} disabled={saving}>
            {prasadamForm.id ? 'Save Prasadam' : 'Add Prasadam'}
          </Button>
          {prasadamForm.id && (
            <Button type="button" variant="outlined" onClick={resetPrasadamForm} disabled={saving}>
              Cancel Edit
            </Button>
          )}
        </Box>

        <Box sx={{ display: 'grid', gap: 1 }}>
          {prasadamItems.map((item) => (
            <Box key={item.id} sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr auto auto auto' }, gap: 1, alignItems: 'center', p: 1, border: '1px solid #eee', borderRadius: 1 }}>
              <Box>
                <Typography variant="body1"><strong>{item.name}</strong></Typography>
                <Typography variant="body2">{item.description || 'No description'}</Typography>
              </Box>
              <Typography variant="body2">${item.price}</Typography>
              <Typography variant="body2">{item.active ? 'Active' : 'Inactive'}</Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button type="button" size="small" variant="outlined" onClick={() => editPrasadamItem(item)}>Edit</Button>
                <Button type="button" size="small" color="error" onClick={() => deletePrasadamItem(item.id)}>Remove</Button>
              </Box>
            </Box>
          ))}
          {prasadamItems.length === 0 && (
            <Typography variant="body2">No prasadam items added yet.</Typography>
          )}
        </Box>
      </Box>

      <Box className="pp-pooja-workspace">
        <Box className="pp-pooja-catalog" component="nav" aria-label="Pooja catalog">
          <Box className="pp-pooja-catalog-heading">
            <Typography variant="subtitle1">Pooja catalog</Typography>
            <span>{poojas.length} {poojas.length === 1 ? 'service' : 'services'}</span>
          </Box>
          <Box className="pp-pooja-catalog-list">
            {poojas.map((pooja) => (
              <button
                type="button"
                key={pooja.id}
                className={selectedId === pooja.id && !isCreatingPooja ? 'active' : ''}
                onClick={() => selectPooja(pooja.id)}
              >
                <strong>{pooja.name}</strong>
                <small>{pooja.pricingTiers?.length || 0} duration{pooja.pricingTiers?.length === 1 ? '' : 's'} · {pooja.active ? 'Active' : 'Inactive'}</small>
              </button>
            ))}
            {poojas.length === 0 && <Typography variant="body2">No poojas yet.</Typography>}
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button size="small" variant="outlined" onClick={startNewPooja} disabled={saving}>+ Add pooja</Button>
            <Button size="small" variant="outlined" onClick={duplicateSelectedPooja} disabled={saving || !selectedPooja}>
              Duplicate selected
            </Button>
          </Box>
        </Box>
        <Box className="pp-pooja-editor">
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <TextField
          select
          label="Pooja"
          value={isCreatingPooja ? '' : selectedId}
          onChange={(e) => selectPooja(e.target.value)}
          sx={{ minWidth: 280, flex: 1 }}
        >
          {isCreatingPooja && <MenuItem value="">New pooja</MenuItem>}
          {poojas.map((pooja) => (
            <MenuItem key={pooja.id} value={pooja.id}>{pooja.name}</MenuItem>
          ))}
        </TextField>
        <Button variant="outlined" onClick={startNewPooja} disabled={saving}>
          Add New Pooja
        </Button>
        <Button variant="outlined" onClick={duplicateSelectedPooja} disabled={saving || !selectedPooja}>
          Duplicate Selected Pooja
        </Button>
          </Box>

          {(selectedPooja || isCreatingPooja) && (
        <>
          <Box component="form" onSubmit={savePoojaDetails} sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
            <Typography variant="subtitle1">{isCreatingPooja ? 'New Pooja Details' : 'Pooja Details'}</Typography>
            {isCreatingPooja && copiedFromPoojaName && (
              <Typography variant="body2" sx={{ color: '#1e5a9d', background: '#eef6ff', border: '1px solid #cfe4ff', borderRadius: 1, p: 1.25 }}>
                Draft copied from <strong>{copiedFromPoojaName}</strong>. The original remains unchanged. Update the name, details, or price card as needed before creating this new pooja; its current image and gallery references will be reused.
              </Typography>
            )}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
              <TextField label="Name" value={detailForm.name} onChange={(e) => updateDetailField('name', e.target.value)} required />
              <TextField label="Title" value={detailForm.title} onChange={(e) => updateDetailField('title', e.target.value)} />
              <TextField label="Pundit count" type="number" value={detailForm.punditCount} onChange={(e) => updateDetailField('punditCount', e.target.value)} inputProps={{ min: 1 }} />
              <TextField label="Sort order" type="number" value={detailForm.sortOrder} onChange={(e) => updateDetailField('sortOrder', e.target.value)} />
            </Box>
            <label>
              <input type="checkbox" checked={detailForm.active} onChange={(e) => updateDetailField('active', e.target.checked)} /> Active
            </label>
            <TextField label="Description" value={detailForm.description} onChange={(e) => updateDetailField('description', e.target.value)} multiline minRows={3} />
            <TextField label="Significance" value={detailForm.significance} onChange={(e) => updateDetailField('significance', e.target.value)} multiline minRows={3} />
            <TextField label="Included items" value={detailForm.includedItems} onChange={(e) => updateDetailField('includedItems', e.target.value)} multiline minRows={3} helperText="One item per line" />
            <TextField label="Why perform this pooja" value={detailForm.whyPerform} onChange={(e) => updateDetailField('whyPerform', e.target.value)} multiline minRows={3} helperText="One reason per line" />
            <TextField label="Ritual process" value={detailForm.ritualProcess} onChange={(e) => updateDetailField('ritualProcess', e.target.value)} multiline minRows={4} helperText="One step per line" />
            <TextField label="Items required" value={detailForm.itemsRequired} onChange={(e) => updateDetailField('itemsRequired', e.target.value)} multiline minRows={3} helperText="One item per line" />
            <TextField label="Preparation" value={detailForm.preparation} onChange={(e) => updateDetailField('preparation', e.target.value)} multiline minRows={2} />

            <Box sx={{ display: 'grid', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="subtitle1">Duration & Prices</Typography>
                <Button type="button" variant="outlined" onClick={addTier}>Add Duration</Button>
              </Box>
              {detailForm.pricingTiers.map((tier, index) => (
                <Box key={`${tier.tierId || 'tier'}-${index}`} sx={{ display: 'grid', gap: 1, p: 1.5, border: '1px solid #eee', borderRadius: 2 }}>
                  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.2fr 1fr 1fr 0.7fr auto' }, gap: 1, alignItems: 'center' }}>
                    <TextField label="Duration" value={tier.duration} onChange={(e) => updateTier(index, 'duration', e.target.value)} required />
                    <TextField label="Original price" type="number" value={tier.price} onChange={(e) => updateTier(index, 'price', e.target.value)} inputProps={{ min: 0, step: '0.01' }} required />
                    <TextField select label="Discount" value={tier.discountType} onChange={(e) => updateTier(index, 'discountType', e.target.value)}><MenuItem value="none">None</MenuItem><MenuItem value="percent">% off</MenuItem><MenuItem value="fixed">$ off</MenuItem></TextField>
                    <TextField label="Discount value" type="number" value={tier.discountValue} onChange={(e) => updateTier(index, 'discountValue', e.target.value)} inputProps={{ min: 0, step: '0.01' }} />
                    <TextField label="Label" value={tier.label} onChange={(e) => updateTier(index, 'label', e.target.value)} />
                    <TextField label="Sort" type="number" value={tier.sortOrder} onChange={(e) => updateTier(index, 'sortOrder', e.target.value)} />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <label><input type="checkbox" checked={tier.active} onChange={(e) => updateTier(index, 'active', e.target.checked)} /> Active</label>
                      <Button type="button" size="small" color="error" onClick={() => removeTier(index)}>Remove</Button>
                    </Box>
                  </Box>
                  <TextField
                    label="Actions performed for this duration"
                    value={tier.actionDetails}
                    onChange={(e) => updateTier(index, 'actionDetails', e.target.value)}
                    multiline
                    minRows={2}
                    helperText="One action per line. These bullets appear on the pooja details page for this duration."
                  />
                  <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 1 }}>
                    <TextField label="Discount label" value={tier.discountLabel} onChange={(e) => updateTier(index, 'discountLabel', e.target.value)} placeholder="Opening offer" />
                    <TextField label="Discount starts" type="datetime-local" value={tier.discountStartsAt} onChange={(e) => updateTier(index, 'discountStartsAt', e.target.value)} InputLabelProps={{ shrink: true }} />
                    <TextField label="Discount ends" type="datetime-local" value={tier.discountEndsAt} onChange={(e) => updateTier(index, 'discountEndsAt', e.target.value)} InputLabelProps={{ shrink: true }} />
                  </Box>
                  {Number(tier.price) > 0 && tier.discountType !== 'none' && (
                    <Typography variant="body2" className="pp-rate-preview">
                      Rate card preview: <del>${Number(tier.price).toFixed(2)}</del> <strong>${discountPreviewPrice(tier.price, tier.discountType, tier.discountValue).toFixed(2)}</strong>
                    </Typography>
                  )}
                </Box>
              ))}
              {detailForm.pricingTiers.length === 0 && (
                <Typography variant="body2">Add at least one duration and price.</Typography>
              )}
            </Box>

            <Button type="submit" variant="outlined" size="small" sx={{ width: 'fit-content' }} disabled={saving}>
              {isCreatingPooja ? 'Create Pooja' : 'Save Pooja Details'}
            </Button>
          </Box>

          {!isCreatingPooja && (
            <Box sx={{ display: 'grid', gap: 2, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
              <Typography variant="subtitle1">Upload New Images</Typography>
              <TextField
                select
                label="Image placement"
                value={uploadType}
                onChange={(e) => setUploadType(e.target.value)}
                sx={{ maxWidth: 280 }}
              >
                <MenuItem value="images">Main card images</MenuItem>
                <MenuItem value="gallery">Details gallery</MenuItem>
              </TextField>
              <input
                key={fileInputKey}
                type="file"
                accept="image/*"
                multiple
                onChange={(e) => setFiles(Array.from(e.target.files || []))}
              />
              <Button variant="contained" onClick={uploadImages} disabled={saving || files.length === 0}>
                Upload Images
              </Button>
            </Box>
          )}

          {!isCreatingPooja && selectedPooja && <Box sx={{ display: 'grid', gap: 2 }}>
            <Typography variant="subtitle1">Main card images</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 1 }}>
              {getImageItems(selectedPooja.storedImages, selectedPooja.images).map((image) => (
                <Box key={image.storedUrl} sx={{ border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
                  <img src={image.previewUrl} alt="" style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }} />
                  <Button size="small" color="error" disabled={saving} onClick={() => removeImage('images', image.storedUrl)}>Remove</Button>
                </Box>
              ))}
              {(selectedPooja.storedImages || []).length === 0 && (
                <Typography variant="body2">No main card images uploaded yet.</Typography>
              )}
            </Box>

            <Typography variant="subtitle1">Details gallery</Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 1 }}>
              {getImageItems(selectedPooja.storedGallery, selectedPooja.gallery).map((image) => (
                <Box key={image.storedUrl} sx={{ border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
                  <img src={image.previewUrl} alt="" style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }} />
                  <Button size="small" color="error" disabled={saving} onClick={() => removeImage('gallery', image.storedUrl)}>Remove</Button>
                </Box>
              ))}
              {(selectedPooja.storedGallery || []).length === 0 && (
                <Typography variant="body2">No detail gallery images uploaded yet.</Typography>
              )}
            </Box>
          </Box>}
        </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const EnterpriseApprovalTab = () => {
  const token = localStorage.getItem('token');
  const [enterpriseRequests, setEnterpriseRequests] = useState([]);
  const [enterpriseLoading, setEnterpriseLoading] = useState(true);
  const [actionId, setActionId] = useState(null);

  const fetchEnterpriseRequests = useCallback(() => {
    setEnterpriseLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/2.0/admin/enterprise-requests?status=PENDING`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setEnterpriseRequests(res.data.data || []))
      .catch((err) => {
        console.error('Error fetching enterprise onboarding requests', err);
        alert(err?.response?.data?.message || 'Unable to load enterprise onboarding requests');
      })
      .finally(() => setEnterpriseLoading(false));
  }, [token]);

  useEffect(() => {
    fetchEnterpriseRequests();
  }, [fetchEnterpriseRequests]);

  const updateEnterpriseStatus = (id, action) => {
    setActionId(id);
    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/api/2.0/admin/enterprise-requests/${id}/${action}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        alert(action === 'approve'
          ? 'Enterprise request approved and email sent!'
          : 'Enterprise request rejected and email sent!');
        setEnterpriseRequests((prev) => prev.filter((request) => request.enterprise_id !== id));
      })
      .catch((err) => {
        console.error(`Error trying to ${action} enterprise request`, err);
        alert(err?.response?.data?.message || `Unable to ${action} enterprise request`);
      })
      .finally(() => setActionId(null));
  };

  if (enterpriseLoading) return <CircularProgress />;

  return (
    <Box>
      <Typography variant="h6">Pending Enterprise Onboarding Requests</Typography>
      {enterpriseRequests.length > 0 ? (
        enterpriseRequests.map((request) => (
          <Box key={request.enterprise_id} sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography><strong>Business:</strong> {request.business_name}</Typography>
            <Typography><strong>Contact:</strong> {request.contact_name}</Typography>
            <Typography><strong>Email:</strong> {request.email}</Typography>
            <Typography><strong>Phone:</strong> {request.phone}</Typography>
            <Typography><strong>Category:</strong> {request.category}</Typography>
            <Typography><strong>City / Location:</strong> {request.city}</Typography>
            <Typography><strong>Business Link:</strong> {request.business_link || 'Not provided'}</Typography>
            <Typography><strong>Support Needed:</strong> {request.support_needed || 'Not provided'}</Typography>
            <Typography><strong>Description:</strong> {request.description || 'Not provided'}</Typography>
            <Typography><strong>Status:</strong> {request.status}</Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="success"
                disabled={actionId === request.enterprise_id}
                onClick={() => updateEnterpriseStatus(request.enterprise_id, 'approve')}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                disabled={actionId === request.enterprise_id}
                onClick={() => updateEnterpriseStatus(request.enterprise_id, 'reject')}
              >
                Reject
              </Button>
            </Box>
          </Box>
        ))
      ) : (
        <Typography>No pending enterprise onboarding requests.</Typography>
      )}
    </Box>
  );
};

const SignupRequestsTab = ({ requests, onApprove, onReject }) => (
  <Box>
    <Typography variant="h6">Pending Signup Requests</Typography>
    {requests.length > 0 ? (
      requests.map((request) => (
        <Box key={request.email} sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
          <Typography><strong>Name:</strong> {request.first_name} {request.last_name}</Typography>
          <Typography><strong>Email:</strong> {request.email}</Typography>
          <Typography><strong>How did you know about us:</strong> {request.knowabout}</Typography>
          <Typography><strong>Reason for joining UC:</strong> {request.resonforjoining}</Typography>
          <Typography><strong>Status:</strong> {request.status}</Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap' }}>
            <Button variant="contained" color="success" onClick={() => onApprove(request.email)}>Approve</Button>
            <Button variant="contained" color="error" onClick={() => onReject(request.email)}>Reject</Button>
          </Box>
        </Box>
      ))
    ) : (
      <Typography>No pending signup requests.</Typography>
    )}
  </Box>
);

const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState('signup-requests');
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const validateAdmin = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/validateAdmin`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setIsAdmin(true);
        fetchRequests(token);
      } catch (err) {
        console.error('Admin validation failed:', err);
        setIsAdmin(false);
        setLoading(false);
      }
    };

    const fetchRequests = (token) => {
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/api/getPendingSignUpRequests`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setRequests(res.data))
        .catch((err) => console.error('Error fetching pending requests', err))
        .finally(() => setLoading(false));
    };

    validateAdmin();
  }, []);

  const handleApprove = (email) => {
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/api/approveSignUp/${email}`, { status: 'approved' })
      .then(() => {
        alert('Signup request approved!');
        setRequests((prev) => prev.filter((request) => request.email !== email));
      })
      .catch((err) => {
        console.error('Error approving request', err);
        alert('Error approving request');
      });
  };

  const handleReject = (email) => {
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/api/rejectSignUp/${email}`, { status: 'rejected' })
      .then(() => {
        alert('Signup request rejected!');
        setRequests((prev) => prev.filter((request) => request.email !== email));
      })
      .catch((err) => {
        console.error('Error rejecting request', err);
        alert('Error rejecting request');
      });
  };

  const activeItem = adminItems.find((item) => item.key === activeSection) || adminItems[0];

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'signup-requests':
        return (
          <SignupRequestsTab
            requests={requests}
            onApprove={handleApprove}
            onReject={handleReject}
          />
        );
      case 'enterprise-onboarding':
        return <EnterpriseApprovalTab />;
      case 'pundit-approvals':
        return <PunditApprovalTab />;
      case 'opportunity-contacts':
        return <OpportunityContactRequests />;
      case 'pooja-management':
        return <PoojaManagementAdminTab />;
      case 'pooja-orders':
        return <PoojaOrdersAdminTab />;
      case 'pooja-testimonials':
        return <PoojaTestimonialsAdminTab />;
      case 'provider-network':
        return <ProviderNetworkAdmin />;
      case 'pooja-subscriptions':
        return <SubscriptionAddonAdminTab />;
      case 'main-banner':
        return <BannerUpload />;
      case 'dynamic-values':
        return <DynamicValuesManager />;
      case 'about-community':
        return <AboutCommunityManager />;
      case 'accomplishments':
        return <Accomplishments />;
      case 'news':
        return <NewsManagement />;
      case 'youtube-links':
        return <YouTubeLinksManager />;
      case 'associations':
        return <AssociationsManager />;
      case 'calendar-events':
        return <Events />;
      case 'event-registrations':
        return <EventRegistrationsManager />;
      case 'community-meetups':
        return <CommunityMeetupsManager />;
      case 'meetup-registrations':
        return <CommunityMeetupRegistrations />;
      case 'event-volunteers':
        return <VolunteerCertificatesManager />;
      case 'training-programs':
        return <TrainingProgramsManager />;
      case 'exam-simulations':
        return <ExamSimulationsAdmin />;
      case 'tech-summit-registrations':
        return <TechSummitRegistrations />;
      case 'gallery-upload':
        return <Galaryimageupload />;
      case 'event-images-upload':
        return <Eventimageupload />;
      case 'help-needed-list':
        return <HelpNeededManager />;
      case 'user-management':
        return <AdminUserManagement />;
      case 'email-communication':
        return <Emailcommunication />;
      case 'site-analytics':
        return <SiteAnalytics />;
      default:
        return null;
    }
  };

  if (loading) return <CircularProgress />;
  if (isAdmin === false) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">Access denied. You are not authorized to view this page.</Typography>
        <Button variant="contained" onClick={() => navigate('/')}>Go to Home</Button>
      </Box>
    );
  }

  return (
    <div className="uc-admin-shell">
      <aside className="uc-admin-sidebar" aria-label="Admin dashboard sections">
        <div className="uc-admin-sidebar-header">
          <span>UC Admin</span>
          <h2>Control Center</h2>
          <p>{adminItems.length} tools grouped by workflow.</p>
        </div>

        <nav className="uc-admin-nav">
          {adminGroups.map((group) => (
            <section className="uc-admin-nav-group" key={group.title}>
              <div className="uc-admin-nav-group-title">
                <strong>{group.title}</strong>
                <small>{group.description}</small>
              </div>
              <div className="uc-admin-nav-items">
                {group.items.map((item) => {
                  const isActive = activeSection === item.key;
                  const badge =
                    item.key === 'signup-requests' && requests.length
                      ? String(requests.length)
                      : '';

                  return (
                    <button
                      type="button"
                      key={item.key}
                      className={`uc-admin-nav-item ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveSection(item.key)}
                      aria-pressed={isActive}
                    >
                      <span>
                        <strong>{item.label}</strong>
                        <small>{item.helper}</small>
                      </span>
                      {badge && <em>{badge}</em>}
                    </button>
                  );
                })}
              </div>
            </section>
          ))}
        </nav>
      </aside>

      <section className="uc-admin-main">
        <header className="uc-admin-main-header">
          <div>
            <span>{activeItem.groupTitle}</span>
            <h1>{activeItem.label}</h1>
            <p>{activeItem.helper}</p>
          </div>
          <button type="button" className="uc-admin-home-btn" onClick={() => navigate('/2.0')}>
            Back to Site
          </button>
        </header>

        <div className="uc-admin-content-card">
          {renderActiveSection()}
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
